import React from 'react';

const MarketResultA = ({ cards, winner, baseUrl }) => {
     if (!cards) return null;
    const cardEntries = Object.entries(cards);
    const isSingleCard = cardEntries.length === 1 && typeof cardEntries[0][1] === "string";
    if (isSingleCard) {
        const [cardKey, cardValue] = cardEntries[0];
        return (
            <div className="col-12 col-md-6 col-xs-12 paati_boxs">
                <h6 className="font-weight-bold">{cardKey.replace('_', ' ')}</h6>
                <div className="card-Img-box">
                    <img src={`${baseUrl}${cardValue}.png`} alt={`Card ${cardKey}`} />
                </div>
            </div>
        );
    }

    return (
        <>
            {Object.entries(cards).map(([playerKey, playerCards]) => (
                <div key={playerKey} className="col-12 col-md-6 col-xs-12 paati_boxs">
                    <h6 className="font-weight-bold">{playerKey.replace('_', ' ')}</h6>
                    <div className="card-Img-box">
                        {Object.entries(playerCards || {})
                            .filter(([_, cardValue]) => typeof cardValue === "string" && cardValue.trim() !== "")
                            .map(([cardKey, cardValue], idx) => (
                                <img key={cardKey} src={`${baseUrl}${cardValue}.png`} alt={`Card ${idx}`} />
                            ))}
                    </div>
                    {winner === playerKey.split('_').pop() && (
                        <button type="button" className={`btn winner-team Winner${playerKey.slice(-1).toLowerCase()}`}>
                            Winner
                        </button>
                    )}
                </div>
            ))}
        </>
    );
};



export default MarketResultA;
